module.exports = __webpack_public_path__ + "static/media/user-shield.ede3d9bf.svg";